import {useEffect, useState} from 'react';
import {IconButton, InputAdornment, TextField, TextFieldProps} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

export default function HoldPasswordField(props: TextFieldProps) {
    const {t} = useAppTranslation();
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const hide = () => setVisible(false);
        window.addEventListener('blur', hide);
        document.addEventListener('visibilitychange', hide);
        return () => {window.removeEventListener('blur', hide); document.removeEventListener('visibilitychange', hide);};
    }, []);
    return <TextField {...props} type={visible && !props.disabled ? 'text' : 'password'}
        sx={{...props.sx, '& input, & .MuiInputBase-root': {cursor: 'default'}}}
        InputProps={{...props.InputProps, endAdornment: <InputAdornment position="end">
            <IconButton type="button" disabled={props.disabled} aria-label={t('auth:recovery.hold_to_show')} aria-pressed={visible}
                onPointerDown={event => {if (event.button !== 0) return; event.currentTarget.setPointerCapture?.(event.pointerId); setVisible(true);}}
                onPointerUp={() => setVisible(false)} onPointerCancel={() => setVisible(false)} onLostPointerCapture={() => setVisible(false)}
                onPointerLeave={() => setVisible(false)} onBlur={() => setVisible(false)}
                onKeyDown={event => {if (event.key === ' ' || event.key === 'Enter') {event.preventDefault(); setVisible(true);}}}
                onKeyUp={event => {if (event.key === ' ' || event.key === 'Enter') {event.preventDefault(); setVisible(false);}}}
                sx={{touchAction: 'none'}}>{visible ? <VisibilityOff/> : <Visibility/>}</IconButton>
        </InputAdornment>}}/>;
}
